import { render, staticRenderFns } from "./InputArea.vue?vue&type=template&id=28c77325"
import script from "./InputArea.vue?vue&type=script&lang=js"
export * from "./InputArea.vue?vue&type=script&lang=js"
import style0 from "./InputArea.vue?vue&type=style&index=0&id=28c77325&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports